var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { o as onResizeDebounced, J as JSbreakpoints, h as hasClass, l as lazyLoadImages, U as UniversalModal, d as ProductGallery, P as ProductConfigurables, b as productSwatches, C as CartComponent, i as initAddToBag, a as cart, p as productQty, c as createLinkFromTemplate, e as JKCart, g as getCartInstance } from "./product-config-BBuQ2RXH.js";
import { b as removeClass, c as addClass, r as renderProductCardsFromHandles } from "./render-product-cards-C86dq60y.js";
import { s as setAndGetSearchspringCookies } from "./manageSearchSpringCookies-BlSmBYu9.js";
function extend(config, obj = {}) {
  Object.keys(config).forEach((key) => {
    if (obj[key] === void 0) {
      obj[key] = config[key];
    } else {
      if (obj[key] && isObject(obj[key]) && isObject(config[key])) {
        Object.keys(config[key]).forEach((childKey) => {
          if (obj[key][childKey] === void 0) {
            obj[key][childKey] = config[key][childKey];
          }
        });
      }
    }
  });
  return obj;
}
function isObject(obj) {
  return obj !== null && typeof obj === "object";
}
function domEvent(opts, applyEvent = true, root = document) {
  if (!opts.id) {
    console.warn("No ID defined.");
    return;
  }
  if (!opts.fn || !opts.event) {
    console.warn("No function or event defined.");
    return;
  }
  let $id;
  let $class;
  let isString = typeof opts.id === "string";
  let hasEvents = opts.event.includes(",");
  function mapElements() {
    $id = isString ? root.getElementById(opts.id) : opts.id;
    if (!$id) {
      console.warn(`Could not find ID: ${opts.id}`);
      return;
    }
    $class = opts.className ? $id.querySelectorAll(`.${opts.className}`) : null;
  }
  function bindLoop() {
    if ($class) {
      $class.forEach(($trigger) => {
        if (applyEvent) {
          if (hasEvents) {
            opts.event.split(",").forEach((ev) => $trigger.addEventListener(ev, opts.fn));
          } else {
            $trigger.addEventListener(opts.event, opts.fn);
          }
        } else {
          $trigger.removeEventListener(opts.event, opts.fn);
        }
      });
    }
  }
  function bindSingle() {
    if ($id) {
      if (applyEvent) {
        if (hasEvents) {
          opts.event.split(",").forEach((ev) => $id.addEventListener(ev, opts.fn));
        } else {
          $id.addEventListener(opts.event, opts.fn);
        }
      } else {
        $id.removeEventListener(opts.event, opts.fn);
      }
    }
  }
  mapElements();
  if (opts.className) {
    bindLoop();
  } else {
    bindSingle();
  }
}
function addEvent(opts, root = document) {
  if (!opts) {
    console.warn("addEvent requires a config object.");
    return;
  }
  domEvent(opts, true, root);
}
function removeEvent(opts, root = document) {
  if (!opts) {
    console.warn("removeEvent requires a config object.");
    return;
  }
  domEvent(opts, false, root);
}
function getParents(elem, selector) {
  var _a;
  const parents = [];
  if (!elem || elem === document) return null;
  let firstChar = selector ? selector.charAt(0) : null;
  for (; elem && elem !== document; elem = elem.parentNode) {
    if (!selector) {
      parents.push(elem);
      continue;
    }
    if (firstChar === "." && ((_a = elem == null ? void 0 : elem.classList) == null ? void 0 : _a.contains(selector.slice(1)))) {
      parents.push(elem);
    } else if (firstChar === "#" && (elem == null ? void 0 : elem.id) === (selector == null ? void 0 : selector.slice(1))) {
      parents.push(elem);
    } else if (firstChar === "[" && (elem == null ? void 0 : elem.hasAttribute(selector == null ? void 0 : selector.slice(1, (selector == null ? void 0 : selector.length) - 1)))) {
      parents.push(elem);
    } else if (firstChar !== "." && firstChar !== "#" && firstChar !== "[" && (elem == null ? void 0 : elem.tagName) && (elem == null ? void 0 : elem.tagName.toLowerCase()) === (selector == null ? void 0 : selector.toLowerCase())) {
      parents.push(elem);
    }
  }
  return parents.length ? parents : null;
}
function slideUp(el) {
  if (!el || !(el instanceof HTMLElement)) return;
  const height = el.offsetHeight;
  el.style.height = `${height}px`;
  el.style.overflow = "hidden";
  void el.offsetHeight;
  el.style.height = "0px";
  el.style.paddingTop = "0px";
  el.style.paddingBottom = "0px";
  const transitionEndHandler = (e) => {
    if (e.target !== el) return;
    el.style.display = "none";
    el.style.removeProperty("height");
    el.style.removeProperty("overflow");
    el.style.removeProperty("padding-top");
    el.style.removeProperty("padding-bottom");
    el.removeEventListener("transitionend", transitionEndHandler);
  };
  el.addEventListener("transitionend", transitionEndHandler);
}
function waitForStableHeight(el, maxTries = 10, delay = 50) {
  return new Promise((resolve) => {
    let tries = 0;
    let lastHeight = el.scrollHeight;
    const check = () => {
      const newHeight = el.scrollHeight;
      if (newHeight === lastHeight || tries >= maxTries) {
        resolve(newHeight);
      } else {
        lastHeight = newHeight;
        tries++;
        setTimeout(check, delay);
      }
    };
    check();
  });
}
async function slideDown(el) {
  if (!el || !(el instanceof HTMLElement)) return;
  el.style.height = "0px";
  el.style.overflow = "hidden";
  el.style.display = "block";
  await new Promise((resolve) => requestAnimationFrame(() => setTimeout(resolve, 10)));
  const stableHeight = await waitForStableHeight(el);
  el.style.height = `${stableHeight}px`;
  el.style.paddingTop = "";
  el.style.paddingBottom = "";
  const transitionEndHandler = (e) => {
    if (e.target !== el) return;
    el.style.height = "";
    el.style.overflow = "";
    el.removeEventListener("transitionend", transitionEndHandler);
  };
  el.addEventListener("transitionend", transitionEndHandler);
}
function triggerEvent(el, eventName, obj = null, bubbles = true, cancelable = true) {
  if (!el || !eventName) return false;
  const event = new CustomEvent(eventName, {
    detail: {
      el,
      time: /* @__PURE__ */ new Date(),
      obj
    },
    bubbles,
    cancelable
  });
  el.dispatchEvent(event);
}
function getHiddenStyles(el) {
  const style = window.getComputedStyle(el);
  const clone = el.cloneNode(true);
  clone.style.visibility = "hidden";
  clone.style.position = "absolute";
  clone.style.display = "block";
  clone.style.height = "auto";
  clone.style.paddingTop = style.paddingTop;
  clone.style.paddingBottom = style.paddingBottom;
  document.body.appendChild(clone);
  const elHeight = clone.offsetHeight;
  const elPaddingTop = style.paddingTop;
  const elPaddingBottom = style.paddingBottom;
  document.body.removeChild(clone);
  return { elHeight, elPaddingTop, elPaddingBottom };
}
function toggleClass(el, className) {
  if (!(el instanceof Element) || typeof className !== "string" || className.trim() === "") return;
  if (el.classList) {
    el.classList.toggle(className);
  } else {
    const classes = el.className.split(" ");
    const index = classes.indexOf(className);
    if (index > -1) {
      classes.splice(index, 1);
    } else {
      classes.push(className);
    }
    el.className = classes.join(" ");
  }
}
function hasOpenMenus() {
  return Array.from(document.querySelectorAll(".menu__item--content")).some(
    (el) => el.classList.contains("visible") && !el.classList.contains("opacity-0")
  );
}
const helpers = {
  extend,
  addEvent,
  removeEvent,
  hasClass,
  getParents,
  addClass,
  removeClass,
  slideUp,
  slideDown,
  triggerEvent,
  getHiddenStyles,
  JSbreakpoints,
  toggleClass,
  hasOpenMenus,
  onResizeDebounced
};
window._JK = window._JK || {};
window._JK.helpers = Object.assign(window._JK.helpers || {}, helpers);
SDG.accordion = function(opts, root = document) {
  const config = {
    cls: {
      active: "is-active",
      // Button active class
      open: "is-open"
    },
    dom: {
      btn: "js-acc-btn",
      // toggle trigger
      id: "acc",
      // id of the accordion
      menu: "js-acc-menu"
      // class to target the menu
    },
    enable_linking: false,
    open_option: null,
    // {number}
    responsive: false,
    // Use responsive?
    scroll: {
      use: false,
      // Use scroll
      scope: "html,body",
      // Scroll scope
      offset_by: 60
      // Integer
    },
    type: "accordion",
    // 'accordion' or 'toggle'
    views: {
      active: null,
      // {array}
      inactive: null,
      // {array}
      current: null
      // {string}
    }
  };
  const c = extend(config, opts);
  const $accordion = root.getElementById(c.dom.id);
  let isSub;
  function init(root2 = document) {
    bindEvents(root2);
    if (c.open_option !== null) {
      openOption(c.open_option);
    }
    if ($accordion) {
      root2.querySelectorAll(`.${c.dom.btn}`).forEach((button, index) => {
        const panelId = button.getAttribute("aria-controls") || `acc-panel-${index + 1}`;
        const panel = root2.getElementById(panelId);
        button.setAttribute("aria-expanded", "false");
        button.setAttribute("aria-controls", panelId);
        if (panel) {
          panel.setAttribute("role", "region");
          panel.setAttribute("aria-labelledby", button.id);
          _JK.helpers.addClass(panel, "hidden");
        }
      });
    }
  }
  function bindEvents(root2 = document) {
    if ($accordion) {
      addEvent({
        id: c.dom.id,
        className: c.dom.btn,
        event: "click",
        fn: checkState
      }, root2);
    }
  }
  function unbindEvents(root2 = document) {
    removeEvent({
      id: c.dom.id,
      className: c.dom.btn,
      event: "click",
      fn: checkState
    }, root2);
  }
  function checkState() {
    const isActive = hasClass(this, c.cls.active);
    const $menu = this.nextElementSibling;
    if (!$menu) return;
    const panelId = this.getAttribute("aria-controls");
    const panel = root.getElementById(panelId);
    this.setAttribute("aria-expanded", !isActive);
    if (panel && !isActive) {
      panel.removeAttribute("hidden");
    }
    const $parentMenu = getParents(this, `.${c.dom.menu}`);
    isSub = Boolean($parentMenu);
    if (isActive) {
      closeMenu($menu);
      removeClass(this, c.cls.active);
    } else {
      openMenu($menu);
      _JK.helpers.addClass(this, c.cls.active);
    }
  }
  function closeMenu(el) {
    const currentHeight = el.offsetHeight;
    const $activeBtns = el.querySelectorAll(`.${c.cls.active}`);
    let $activeBtn;
    let $activeMenu;
    el.style.height = `${currentHeight}px`;
    slideUp(el);
    removeClass(el, c.cls.open);
    if ($activeBtns.length > 0) {
      Object.keys($activeBtns).forEach((key) => {
        $activeBtn = $activeBtns[key];
        $activeMenu = $activeBtn.nextElementSibling;
        removeClass($activeBtn, c.cls.active);
        removeClass($activeMenu, c.cls.open);
        slideUp($activeMenu);
      });
    }
  }
  function openMenu(el) {
    let $activeBtn;
    let $activeBtns;
    let $activeMenu;
    let $parentMenu;
    if (c.type === "accordion") {
      if (isSub) {
        $parentMenu = getParents(el, `.${c.cls.open}`);
        Object.keys($parentMenu).forEach((key) => {
          if ($parentMenu[key] && $parentMenu[key] !== el) {
            $parentMenu = $parentMenu[key];
          }
        });
        $activeBtns = $parentMenu.querySelectorAll(`.${c.dom.btn}.${c.cls.active}`);
      } else {
        $activeBtns = $accordion.querySelectorAll(`.${c.cls.active}`);
      }
      if ($activeBtns.length > 0) {
        Object.keys($activeBtns).forEach((key) => {
          $activeBtn = $activeBtns[key];
          $activeMenu = $activeBtn.nextElementSibling;
          closeMenu($activeMenu);
          removeClass($activeBtn, c.cls.active);
          removeClass($activeMenu, c.cls.open);
        });
      }
    }
    slideDown(el);
    _JK.helpers.addClass(el, c.cls.open);
    el.setAttribute("aria-hidden", "false");
    const firstInput = el.querySelector("input");
    if (firstInput) firstInput.focus();
    if (isSub) {
      $parentMenu = getParents(el, `.${c.cls.open}`);
      Object.keys($parentMenu).forEach((key) => {
        if ($parentMenu[key] && $parentMenu[key] !== el) {
          $parentMenu = $parentMenu[key];
          $parentMenu.style.height = "";
        }
      });
    }
  }
  function closeAllMenus() {
    const $activeTriggers = $accordion.querySelectorAll(`.${c.dom.btn}.${c.cls.active}`);
    let $trigger;
    let $menu;
    let i;
    if ($activeTriggers.length > 0) {
      for (i = 0; i < $activeTriggers.length; i += 1) {
        $trigger = $activeTriggers[i];
        $menu = $trigger.nextElementSibling;
        removeClass($trigger, c.cls.active);
        closeMenu($menu);
      }
    }
  }
  function openOption(option) {
    const $activeTriggers = $accordion.querySelectorAll(`.${c.dom.btn}`);
    let $trigger = typeof option === "number" ? $activeTriggers[option] : [...$activeTriggers].find((el) => el.dataset.accordionId === option);
    if ($trigger) {
      const $menu = $trigger.nextElementSibling;
      openMenu($menu);
      _JK.helpers.addClass($menu, c.cls.open);
      _JK.helpers.addClass($trigger, c.cls.active);
      $trigger.setAttribute("aria-expanded", "true");
      _JK.helpers.removeClass($menu, "hidden");
    }
  }
  return {
    init,
    closeAll: closeAllMenus,
    closeMenu,
    unbindEvents
  };
};
SDG.accordionRedesign = function(opts, root = document) {
  const config = {
    cls: {
      active: "is-active",
      // Button active class
      open: "is-open"
    },
    dom: {
      btn: "js-acc-btn",
      // toggle trigger
      id: "acc",
      // id of the accordion
      menu: "js-acc-menu"
      // class to target the menu
    },
    enable_linking: false,
    open_option: null,
    // {number}
    responsive: false,
    // Use responsive?
    scroll: {
      use: false,
      // Use scroll
      scope: "html,body",
      // Scroll scope
      offset_by: 60
      // Integer
    },
    type: "accordion",
    // 'accordion' or 'toggle'
    views: {
      active: null,
      // {array}
      inactive: null,
      // {array}
      current: null
      // {string}
    }
  };
  const c = extend(config, opts);
  const $accordion = root.getElementById(c.dom.id);
  let isSub;
  function init(root2 = document) {
    bindEvents(root2);
    if (c.open_option !== null) {
      openOption(c.open_option);
    }
    if ($accordion) {
      root2.querySelectorAll(`.${c.dom.btn}`).forEach((button, index) => {
        const panelId = button.getAttribute("aria-controls") || `acc-panel-${index + 1}`;
        const panel = root2.getElementById(panelId);
        button.setAttribute("aria-expanded", "false");
        button.setAttribute("aria-controls", panelId);
        if (panel) {
          panel.setAttribute("role", "region");
          panel.setAttribute("aria-labelledby", button.id);
          _JK.helpers.addClass(panel, "hidden");
        }
      });
    }
  }
  function bindEvents(root2 = document) {
    if ($accordion) {
      addEvent({
        id: c.dom.id,
        className: c.dom.btn,
        event: "click",
        fn: checkState
      }, root2);
    }
  }
  function unbindEvents(root2 = document) {
    removeEvent({
      id: c.dom.id,
      className: c.dom.btn,
      event: "click",
      fn: checkState
    }, root2);
  }
  function checkState() {
    const isActive = hasClass(this, c.cls.active);
    const $menu = this.nextElementSibling;
    if (!$menu) return;
    const panelId = this.getAttribute("aria-controls");
    const panel = root.getElementById(panelId);
    this.setAttribute("aria-expanded", !isActive);
    if (panel && !isActive) {
      panel.removeAttribute("hidden");
    }
    const $parentMenu = getParents(this, `.${c.dom.menu}`);
    isSub = Boolean($parentMenu);
    if (isActive) {
      closeMenu($menu);
      removeClass(this, c.cls.active);
    } else {
      openMenu($menu);
      _JK.helpers.addClass(this, c.cls.active);
    }
  }
  function closeMenu(el) {
    const currentHeight = el.offsetHeight;
    const $activeBtns = el.querySelectorAll(`.${c.cls.active}`);
    let $activeBtn;
    let $activeMenu;
    el.style.height = `${currentHeight}px`;
    slideUp(el);
    removeClass(el, c.cls.open);
    if ($activeBtns.length > 0) {
      Object.keys($activeBtns).forEach((key) => {
        $activeBtn = $activeBtns[key];
        $activeMenu = $activeBtn.nextElementSibling;
        removeClass($activeBtn, c.cls.active);
        removeClass($activeMenu, c.cls.open);
        slideUp($activeMenu);
      });
    }
  }
  function openMenu(el) {
    let $activeBtn;
    let $activeBtns;
    let $activeMenu;
    let $parentMenu;
    if (c.type === "accordion") {
      if (isSub) {
        $parentMenu = getParents(el, `.${c.cls.open}`);
        Object.keys($parentMenu).forEach((key) => {
          if ($parentMenu[key] && $parentMenu[key] !== el) {
            $parentMenu = $parentMenu[key];
          }
        });
        $activeBtns = $parentMenu.querySelectorAll(`.${c.dom.btn}.${c.cls.active}`);
      } else {
        $activeBtns = $accordion.querySelectorAll(`.${c.cls.active}`);
      }
      if ($activeBtns.length > 0) {
        Object.keys($activeBtns).forEach((key) => {
          $activeBtn = $activeBtns[key];
          $activeMenu = $activeBtn.nextElementSibling;
          closeMenu($activeMenu);
          removeClass($activeBtn, c.cls.active);
          removeClass($activeMenu, c.cls.open);
        });
      }
    }
    slideDown(el);
    _JK.helpers.addClass(el, c.cls.open);
    el.setAttribute("aria-hidden", "false");
    const firstInput = el.querySelector("input");
    if (firstInput) firstInput.focus();
    if (isSub) {
      $parentMenu = getParents(el, `.${c.cls.open}`);
      Object.keys($parentMenu).forEach((key) => {
        if ($parentMenu[key] && $parentMenu[key] !== el) {
          $parentMenu = $parentMenu[key];
          $parentMenu.style.height = "";
        }
      });
    }
  }
  function closeAllMenus() {
    const $activeTriggers = $accordion.querySelectorAll(`.${c.dom.btn}.${c.cls.active}`);
    let $trigger;
    let $menu;
    let i;
    if ($activeTriggers.length > 0) {
      for (i = 0; i < $activeTriggers.length; i += 1) {
        $trigger = $activeTriggers[i];
        $menu = $trigger.nextElementSibling;
        removeClass($trigger, c.cls.active);
        closeMenu($menu);
      }
    }
  }
  function openOption(option) {
    const $activeTriggers = $accordion.querySelectorAll(`.${c.dom.btn}`);
    let $trigger = typeof option === "number" ? $activeTriggers[option] : [...$activeTriggers].find((el) => el.dataset.accordionId === option);
    if ($trigger) {
      const $menu = $trigger.nextElementSibling;
      openMenu($menu);
      _JK.helpers.addClass($menu, c.cls.open);
      _JK.helpers.addClass($trigger, c.cls.active);
      $trigger.setAttribute("aria-expanded", "true");
      _JK.helpers.removeClass($menu, "hidden");
    }
  }
  return {
    init,
    closeAll: closeAllMenus,
    closeMenu,
    unbindEvents
  };
};
const _RedesignMegaMenu = class _RedesignMegaMenu {
  constructor(menuElement) {
    /**
    * Handles hover effect when a user hovers over a link inside the open mega menu.
    * Adds a class to all sibling links to dim them, highlighting the hovered link.
    */
    __publicField(this, "handleLinkEnter", (e) => {
      const hoveredLink = e.currentTarget;
      this.menuLinks.forEach((link) => {
        if (link !== hoveredLink) link.classList.add("!text-charcoal-80");
      });
    });
    /**
     * Resets all link styles when the user moves the pointer off any link.
     * This removes the dimmed state from sibling links.
     */
    __publicField(this, "handleLinkLeave", () => {
      this.menuLinks.forEach((link) => {
        link.classList.remove("!text-charcoal-80");
      });
    });
    var _a;
    this.menuElement = menuElement;
    this.header = document.querySelector("header");
    this.menuLabel = this.menuElement.getAttribute("label") || "Menu";
    this.button = this.menuElement.querySelector(".sub-item.has--dropdown");
    this.menuContent = this.menuElement.querySelector(".menu__item--content");
    this.menuContent.style.width = `100vw`;
    const contentContainer = (_a = this.menuContent) == null ? void 0 : _a.querySelector(".menu__item--content-container");
    this.waitForSize(contentContainer, (rect) => {
      this.menuContentHeight = {
        [this.menuContent.getAttribute("id")]: rect.height
      };
      this.menuContent.style.height = 0;
      this.menuContent.style.width = "";
    });
    _JK.helpers.addClass(document.body, "nav-overlay");
    this.isOpen = false;
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.button.addEventListener("mouseenter", () => this.openMenu());
    this.button.addEventListener("mouseleave", () => this.delayedClose());
    if (this.menuContent) {
      this.menuContent.addEventListener("mouseleave", () => this.delayedClose());
      this.menuContent.addEventListener("mouseenter", () => {
        clearTimeout(this._closeTimeout);
      });
    }
    this._boundHeaderMouseLeave = this.handleHeaderMouseLeave.bind(this);
    this.header.addEventListener("mouseleave", this._boundHeaderMouseLeave);
    window.addEventListener("mousemove", (e) => {
      window._lastMouseX = e.clientX;
      window._lastMouseY = e.clientY;
    });
    document.addEventListener("click", this.handleDocumentClick);
    document.addEventListener("mouseleave", this.handleDocumentMouseLeave.bind(this));
  }
  openMenu() {
    if (!this.menuContent || this.isOpen) return;
    this.menuContent.classList.remove("pointer-events-none");
    this.isOpen = true;
    this.button.setAttribute("aria-expanded", "true");
    this.updateMenuPosition();
    lazyLoadImages();
    window.addEventListener("resize", this.updateMenuPosition.bind(this));
    _JK.helpers.addClass(this.header, "header-hover");
    if (_RedesignMegaMenu.openMenus === 0) {
      _JK.helpers.addClass(document.body, "nav-overlay-active");
    }
    _RedesignMegaMenu.openMenus++;
    this.menuLinks = this.menuContent.querySelectorAll("ul li a");
    this.menuLinks.forEach((link) => {
      link.addEventListener("mouseenter", this.handleLinkEnter);
      link.addEventListener("mouseleave", this.handleLinkLeave);
    });
    this.menuContent.style.height = `${this.menuContentHeight[this.menuContent.getAttribute("id")]}px`;
    this.menuContent.classList.add("visible");
  }
  handleHeaderMouseLeave() {
    this._closeTimeout = setTimeout(() => {
      if (!this._isPointerOver()) {
        this.closeMenu();
      }
    }, 50);
  }
  handleDocumentMouseLeave(e) {
    if (!e.relatedTarget && this.isOpen && !this.forceOpen) {
      this.closeMenu();
    }
  }
  updateMenuPosition() {
    if (!this.menuContent) return;
    const buttonRect = this.button.getBoundingClientRect();
    const viewportWidth = document.documentElement.clientWidth;
    this.menuContent.style.top = `${buttonRect.height}px`;
    this.menuContent.style.width = `${viewportWidth}px`;
    if (viewportWidth > 1920) {
      const sideGutter = (viewportWidth - 1920) / 2;
      this.menuContent.style.left = `calc(100% - ${buttonRect.left + buttonRect.width - sideGutter}px)`;
    } else {
      this.menuContent.style.left = `calc(100% - ${buttonRect.left + buttonRect.width}px)`;
    }
  }
  delayedClose() {
    this._closeTimeout = setTimeout(() => {
      if (!this._isPointerOver()) {
        this.closeMenu();
      }
    }, 50);
  }
  closeMenu() {
    if (!this.menuContent || !this.isOpen || this.forceOpen) return;
    this.menuContent.classList.add("pointer-events-none");
    this.isOpen = false;
    this.button.setAttribute("aria-expanded", "false");
    this.menuContent.classList.remove("visible");
    this.menuContent.style.height = 0;
    if (this.menuLinks) {
      this.menuLinks.forEach((link) => {
        link.removeEventListener("mouseenter", this.handleLinkEnter);
        link.removeEventListener("mouseleave", this.handleLinkLeave);
      });
      this.menuLinks = null;
    }
    _JK.helpers.removeClass(this.header, "header-hover");
    if (_RedesignMegaMenu.openMenus > 0) {
      _RedesignMegaMenu.openMenus--;
    }
    if (_RedesignMegaMenu.openMenus === 0) {
      _JK.helpers.removeClass(document.body, "nav-overlay-active");
    }
  }
  _isPointerOver() {
    var _a;
    const x = window._lastMouseX;
    const y = window._lastMouseY;
    if (x == null || y == null) return false;
    const btnRect = this.button.getBoundingClientRect();
    const menuRect = (_a = this.menuContent) == null ? void 0 : _a.getBoundingClientRect();
    const overButton = x >= btnRect.left && x <= btnRect.right && y >= btnRect.top && y <= btnRect.bottom;
    const overMenu = menuRect && x >= menuRect.left && x <= menuRect.right && y >= menuRect.top && y <= menuRect.bottom;
    return overButton || overMenu;
  }
  handleDocumentClick(e) {
    if (!this.isOpen) return;
    const clickedInsideButton = this.button.contains(e.target);
    const clickedInsideMenu = this.menuContent && this.menuContent.contains(e.target);
    const clickedInsideHeader = this.header && this.header.contains(e.target);
    if (!clickedInsideButton && !clickedInsideMenu && !clickedInsideHeader) {
      this.closeMenu();
    }
  }
  waitForSize(el, callback) {
    if (!el) return;
    const check = () => {
      const rect = el.getBoundingClientRect();
      if (rect.height > 0 && rect.width > 0) {
        callback(rect);
        return true;
      }
      return false;
    };
    if (!check()) {
      const ro = new ResizeObserver(() => {
        if (check()) {
          ro.disconnect();
        }
      });
      ro.observe(el);
    }
  }
  destroy() {
    document.removeEventListener("click", this.handleDocumentClick);
    window.removeEventListener("resize", this.updateMenuPosition);
    document.removeEventListener("mouseleave", this.handleDocumentMouseLeave);
    this.header.removeEventListener("mouseleave", this._boundHeaderMouseLeave);
  }
};
__publicField(_RedesignMegaMenu, "openMenus", 0);
let RedesignMegaMenu = _RedesignMegaMenu;
class AccountDrawer {
  constructor(root = document) {
    this.rootInstance = root;
    this.container = this.rootInstance.querySelector(".account-drawer");
    this.drawerTrigger = this.rootInstance.querySelector(".account-link");
    if (!this.drawerTrigger) {
      console.warn("AccountDrawer: No trigger element found (.account-link). Exiting.");
      return;
    }
  }
  init() {
    if (!this.drawerTrigger) return;
    this.backdrop = this.rootInstance.querySelector("#account-drawer-backdrop");
    this.closeBtn = this.container.querySelector(".close-btn");
    this.attachListeners();
    this.retrieveAndFormatYotpoRewards();
  }
  attachListeners() {
    var _a, _b, _c;
    (_a = this.drawerTrigger) == null ? void 0 : _a.addEventListener("click", this.openDrawer.bind(this));
    (_b = this.closeBtn) == null ? void 0 : _b.addEventListener("click", this.closeDrawer.bind(this));
    (_c = this.container) == null ? void 0 : _c.addEventListener("click", (e) => {
      if (!e.target.closest(".main-dialog")) {
        this.closeDrawer();
      }
    });
    this.rootInstance.addEventListener("click", this.handleOutsideClick.bind(this));
  }
  handleOutsideClick(event) {
    if (!this.container.classList.contains("open")) return;
    if (!this.container.contains(event.target) && !this.drawerTrigger.contains(event.target)) {
      this.closeDrawer();
    }
  }
  openDrawer(e) {
    var _a, _b;
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    (_a = this.backdrop) == null ? void 0 : _a.classList.add("opacity-100");
    (_b = this.backdrop) == null ? void 0 : _b.classList.remove("opacity-0", "pointer-events-none");
    this.container.classList.remove("translate-x-full");
    _JK.helpers.addClass(document.body, "overflow-hidden");
    this.drawerTrigger.setAttribute("aria-expanded", "true");
  }
  closeDrawer() {
    var _a;
    this.container.classList.add("translate-x-full");
    this.backdrop.classList.remove("opacity-100");
    this.backdrop.classList.add("opacity-0", "pointer-events-none");
    _JK.helpers.removeClass(document.body, "overflow-hidden");
    (_a = this.drawerTrigger) == null ? void 0 : _a.setAttribute("aria-expanded", "false");
  }
  retrieveAndFormatYotpoRewards() {
    document.addEventListener("swell:setup", () => {
      const customerDetails = globalThis.swellAPI.getCustomerDetails();
      const numberContainer = this.container.querySelectorAll(".custom-swell-point-balance");
      if (numberContainer && customerDetails) {
        const currentNumber = parseFloat(customerDetails.pointsBalance);
        if (currentNumber !== void 0 && currentNumber !== null) {
          const formattedNumber = currentNumber.toLocaleString();
          numberContainer.forEach((rewardItem) => {
            rewardItem.textContent = `${formattedNumber}`;
          });
        }
      }
    });
  }
}
class QuickView {
  /**
   * Constructor
   * @param {Object} config - Configuration object
   * @param {string} config.modalSelector - Selector for the modal element
   * @param {string} config.triggerSelector - Selector for quickview triggers
   * @param {string} config.closeSelector - Selector for modal close buttons
   */
  constructor(root = document, {
    modalSelector = ".modal--quick-add-edit",
    triggerSelector = ".quickview--minipdp",
    closeSelector = "#close-quick-add-edit-modal"
  } = {}) {
    this.rootSelector = root;
    this.modalSelector = modalSelector;
    this.triggerSelector = triggerSelector;
    this.closeSelector = closeSelector;
    this.quickViewModal = new UniversalModal(this.modalSelector, this.triggerSelector, this.closeSelector, this.rootSelector);
    this.modalElement = this.rootSelector.querySelector(modalSelector);
    this.quickViewComponent = this.rootSelector.querySelector(".quickview__component");
    this.handle = "";
    this.handleModalShownBound = this.handleModalShown.bind(this);
    this.handleItemAddedBound = this.handleItemAdded.bind(this);
    this.registerEvents();
  }
  /**
   * Binds event listeners
   * - Listens for modal open and item added events
   */
  registerEvents() {
    if (!this.modalElement) return;
    this.modalElement.removeEventListener("modal:shown", this.handleModalShownBound);
    this.modalElement.addEventListener("modal:shown", this.handleModalShownBound);
    window.removeEventListener("jkCart:added-item", this.handleItemAddedBound);
    window.addEventListener("jkCart:added-item", this.handleItemAddedBound);
  }
  /**
   * Handles the "modal:shown" event
   * @param {CustomEvent|Object} e - Event containing product handle in `e.detail.handle` or `e.handle`
   * @param {CustomEvent|Object} el - active element, could be null or DOM
   */
  async handleModalShown(e, el = null) {
    var _a, _b;
    this.handle = ((_a = e.detail) == null ? void 0 : _a.handle) || e.handle;
    if (!this.handle) return console.warn("No product handle provided in modal:shown event.");
    try {
      const res = await fetch(`/products/${this.handle}?sections=redesign-main-product&view=redesign-quickview`, {
        headers: { "Accept": "text/html" }
      });
      const data = await res.json();
      if (el) {
        const productForm = el.closest(".product-essentials--wrapper").querySelector("form");
        const activeSize = (_b = productForm.querySelector('input[name="options[Size]"]:checked')) == null ? void 0 : _b.value;
        this.renderQuickView(data["redesign-main-product"], activeSize);
      } else {
        this.renderQuickView(data["redesign-main-product"]);
      }
    } catch (err) {
      console.error("Failed to load quickview product:", err);
    }
  }
  /**
   * Renders the quickview content inside the modal
   * @param {string} sectionHtml - HTML string from the product section
   */
  renderQuickView(sectionHtml, activeSize = "") {
    var _a, _b, _c, _d, _e, _f, _g;
    if (!this.quickViewComponent) return;
    sectionHtml = sectionHtml.replace(/{width}/g, () => "28");
    sectionHtml = sectionHtml.replace(/lazyload/g, (match) => {
      if (match.startsWith("lazyload")) return "custom__lazy";
    });
    this.quickViewComponent.innerHTML = sectionHtml;
    const section = this.quickViewComponent.querySelector("#shopify-section-redesign-main-product");
    section == null ? void 0 : section.classList.remove("mt-50");
    section == null ? void 0 : section.classList.add("lg:py-28", "lg:pl-28", "lg:pr-32");
    const modalTitle = document.createElement("span");
    modalTitle.innerText = "Quick View:";
    modalTitle.classList.add("redesign-body-5");
    const navHandler = (_a = this.quickViewComponent) == null ? void 0 : _a.querySelector(".heading-wrapper-mobile");
    if (navHandler) {
      navHandler.classList.remove("pt-28", "pb-24", "p-0", "px-20");
      navHandler.classList.add("py-18", "px-28", "top-0", "sticky", "z-101", "bg-ivory", "rounded-[10px_10px_0px_0px]");
      navHandler.innerHTML = "";
      navHandler.appendChild(modalTitle);
    }
    const productForm = (_b = this.quickViewComponent) == null ? void 0 : _b.querySelector("#addToBagForm");
    if (productForm) {
      productForm == null ? void 0 : productForm.setAttribute("id", "addViewToBagForm");
    }
    const productContainer = (_c = this.quickViewComponent) == null ? void 0 : _c.querySelector("#product");
    if (productContainer) {
      productContainer == null ? void 0 : productContainer.setAttribute("id", "quickview-product");
      productContainer.classList.remove("lg:gap-100");
      productContainer.classList.add("lg:gap-32", "overflow-y-auto", "max-h-screen");
    }
    const essentials = (_d = this.quickViewComponent) == null ? void 0 : _d.querySelector(".redesign-product-essentials");
    if (essentials) {
      essentials == null ? void 0 : essentials.classList.remove("lg:mr-100", "lg:pt-80", "px-20");
      essentials == null ? void 0 : essentials.classList.add("px-28", "lg:pt-0", "pt-24", "lg:pb-0", "pb-85");
    }
    const navDesktopHandler = essentials.querySelector(".heading-wrapper-desktop");
    if (navDesktopHandler) {
      (_e = navDesktopHandler.querySelector("h1")) == null ? void 0 : _e.classList.remove("mt-12", "mb-8");
      (_f = navDesktopHandler.querySelector("h1")) == null ? void 0 : _f.classList.add("lg:w-full", "w-[65%]");
      navDesktopHandler.classList.remove("pt-28", "pb-24", "px-20", "hidden");
      navDesktopHandler.classList.add("lg:pt-40", "pt-0", "px-0", "relative");
      const fullDetailsWrapper = document.createElement("div");
      fullDetailsWrapper.classList.add("lg:relative", "absolute", "lg:top-12", "top-0", "right-0", "flex", "items-center");
    }
    const productFormWrapper = essentials.querySelector(".product-form--wrapper");
    if (productFormWrapper) {
      productFormWrapper == null ? void 0 : productFormWrapper.classList.remove("pb-12");
    }
    this.quickViewComponent.classList.remove("hidden");
    const galleryWrapper = this.quickViewComponent.querySelector(".product-image--gallery");
    galleryWrapper == null ? void 0 : galleryWrapper.classList.remove("mb-24");
    const gallery = this.quickViewComponent.querySelector("#gallery-carousel-mini-pdp");
    gallery == null ? void 0 : gallery.classList.remove("mb-4");
    if (gallery) {
      gallery.classList.remove("hidden");
      const galleryViewCartEl = this.quickViewComponent.querySelector("#gallery-carousel-mini-pdp");
      new ProductGallery(galleryViewCartEl, "", 1023, {
        useThumbs: false,
        thumbsOn: "none",
        splideOptions: {
          type: "slide",
          perPage: 1,
          pagination: false,
          arrows: true,
          heightRatio: 1,
          cover: true,
          keyboard: "global",
          focus: "left",
          breakpoints: {
            1023: {
              drag: true,
              heightRatio: 0.78,
              autoHeight: true,
              perPage: 1.54,
              arrows: false
            }
          }
        }
      }, true);
    }
    (_g = this.quickViewComponent.querySelector(".swatches-color--wrapper")) == null ? void 0 : _g.addEventListener("click", (e) => {
      e.preventDefault();
      const el = e.target.closest(".swatch--link");
      if (el) {
        this.handleModalShown(el.dataset, el);
      }
    });
    this.setupVariantRedirectHandler();
    this.initProductScripts(activeSize);
    if (window.yotpoWidgetsContainer) window.yotpoWidgetsContainer.initWidgets();
  }
  /**
   * Initializes product form behaviors: options, swatches, lazy images
   */
  async initProductScripts(activeSize) {
    const $productForm = this.quickViewComponent.querySelector("#addViewToBagForm");
    const $productSection = this.quickViewComponent.querySelector("#quickview-product");
    if (!$productForm || !$productSection) {
      console.warn("Product form or section not found. Skipping configurable initialization.");
      return;
    }
    $productForm.querySelectorAll(".js-option").forEach((jsOption, index) => {
      const optionInput = jsOption.querySelector("input");
      const optionlabel = jsOption.querySelector("label");
      if (!optionInput || !optionlabel) return;
      const optionNewId = `${optionInput.getAttribute("id")}-${index}-qv`;
      optionInput.setAttribute("id", `${optionNewId}`);
      optionlabel.setAttribute("for", `${optionNewId}`);
    });
    const productConfigurables = new ProductConfigurables({
      productForm: $productForm,
      productSection: $productSection
    });
    productConfigurables.init();
    productSwatches();
    lazyLoadImages(this.quickViewComponent);
    if (this.rootSelector instanceof ShadowRoot) {
      const cartCustomTag = document.querySelector("jk-cart-drawer");
      const cartObj = new CartComponent(cartCustomTag.shadowRoot);
      initAddToBag(cartObj, this.quickViewComponent);
    } else {
      initAddToBag(cart, this.quickViewComponent);
    }
    productQty(document, $productForm);
    const input = $productForm.querySelector(`input[name="options[Size]"][value="${activeSize}"]`);
    if (input) {
      input.checked = true;
      (async () => {
        productConfigurables.updateSwatchAvailability(activeSize);
      })();
    }
  }
  /**
   * Handles jkCart:added-item event by closing modal for added product
   * @param {CustomEvent} e - Event with addedItem.handle
   */
  handleItemAdded(e) {
    var _a, _b;
    if (this.quickViewModal.isOpen) {
      const addedItem = (_a = e.detail) == null ? void 0 : _a.addedItem;
      if (!(addedItem == null ? void 0 : addedItem.handle)) return;
      const trigger = this.rootSelector.querySelector(`[data-handle="${addedItem.handle}"].quickview--minipdp`);
      trigger == null ? void 0 : trigger.setAttribute("aria-expanded", false);
      (_b = this.quickViewModal) == null ? void 0 : _b.close();
    }
  }
  setupVariantRedirectHandler() {
    if (!this.quickViewComponent) return;
    if (this._boundVariantRedirectClick) {
      this.quickViewComponent.removeEventListener("click", this._boundVariantRedirectClick);
    }
    this._boundVariantRedirectClick = (e) => {
      const link = e.target.closest(".js-variant-option-redirect");
      if (!link) return;
      e.preventDefault();
      this.handleVariantRedirect(link.getAttribute("href"));
    };
    this.quickViewComponent.addEventListener("click", this._boundVariantRedirectClick);
  }
  async handleVariantRedirect(relativeUrl) {
    if (!relativeUrl) return;
    try {
      const url = new URL(relativeUrl, window.location.origin);
      const endpoint = `${url.pathname}${url.search}${url.search ? "&" : "?"}sections=redesign-main-product&view=redesign-quickview`;
      const res = await fetch(endpoint, { headers: { "Accept": "text/html" } });
      const data = await res.json();
      this.renderQuickView(data["redesign-main-product"]);
    } catch (err) {
      console.error("Failed to load redirected quickview product:", err);
    }
  }
}
class SearchSpringElement {
  constructor(shadowRoot = document) {
    this.shadowRoot = shadowRoot;
    this.SDG = window.SDG;
    const {
      sessionCookie,
      userId,
      pageLoadId
    } = setAndGetSearchspringCookies();
    this.config = {
      url: {
        suggestionEndPoint: `https://${this.SDG.Data.ssId}.a.searchspring.io/api/suggest/query?siteId=${this.SDG.Data.ssId}&sessionId=${sessionCookie}&userId=${userId}&pageLoadId=${pageLoadId}`,
        searchEndpoint: `https://${this.SDG.Data.ssId}.a.searchspring.io/api/search/autocomplete.json?siteId=${this.SDG.Data.ssId}&sessionId=${sessionCookie}&userId=${userId}&pageLoadId=${pageLoadId}`
      }
    };
    this.searchContainer = this.shadowRoot.querySelector(".search__component");
    if (this.searchContainer) {
      this.render();
      this.buildRecommendations();
      this.searchSuggestion = this.searchContainer.querySelector(".search-suggestions");
      this.searchAutocomplete = this.searchContainer.querySelector(".autocomplete");
      this.searchIconListener();
      this.noResultsContainer = this.searchContainer.querySelector(".js-no-results");
    }
    this.searchModal = this.shadowRoot.querySelector(".modal-search");
    this.QuickView = new QuickView(this.shadowRoot);
  }
  init() {
    this.searchInput = this.shadowRoot.querySelector(".search-input");
    this.handleSearchResize = this.handleSearchResize.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.onSearchShow = this.onSearchShow.bind(this);
    this.onSearchHide = this.onSearchHide.bind(this);
    this.searchInput.removeEventListener("input", this.handleSearch);
    this.searchModal.removeEventListener("modal:shown", this.onSearchShow);
    this.searchModal.removeEventListener("modal:closed", this.onSearchHide);
    window.removeEventListener("resize", this.handleSearchResize);
    this.searchInput.addEventListener("input", this.handleSearch);
    this.searchModal.addEventListener("modal:shown", this.onSearchShow);
    this.searchModal.addEventListener("modal:closed", this.onSearchHide);
    this.handleSearchResize();
    window.addEventListener("resize", this.handleSearchResize);
  }
  onSearchShow(e) {
    const modal = e.target;
    if (window.innerWidth <= 768) {
      modal.classList.remove("-translate-x-full");
      modal.classList.add("translate-x-0");
      setTimeout(() => {
        const wrapper = modal.querySelector(".modal-search--wrapper");
        wrapper == null ? void 0 : wrapper.classList.remove("-translate-x-full");
        wrapper == null ? void 0 : wrapper.classList.add("translate-x-0");
      }, 300);
    } else {
      modal == null ? void 0 : modal.classList.add("md:translate-y-0", "transition-opacity");
      modal == null ? void 0 : modal.classList.remove("md:translate-y-[-100%]");
      setTimeout(() => {
        const modalSearchWrapperEl = modal.querySelector(".modal-search--wrapper");
        modalSearchWrapperEl == null ? void 0 : modalSearchWrapperEl.classList.remove("md:translate-y-[-100%]");
        modalSearchWrapperEl == null ? void 0 : modalSearchWrapperEl.classList.add("md:translate-y-0");
      }, 50);
    }
    setTimeout(() => {
      var _a;
      (_a = this.searchInput) == null ? void 0 : _a.focus();
    }, 50);
  }
  onSearchHide(e) {
    const modal = e.target;
    if (window.innerWidth <= 768) {
      const wrapper = modal.querySelector(".modal-search--wrapper");
      setTimeout(() => {
        wrapper == null ? void 0 : wrapper.classList.remove("translate-x-0");
        wrapper == null ? void 0 : wrapper.classList.add("-translate-x-full");
      }, 600);
      setTimeout(() => {
        modal == null ? void 0 : modal.classList.remove("translate-x-0");
        modal == null ? void 0 : modal.classList.add("-translate-x-full");
      }, 300);
    } else {
      const modalSearchWrapperEl = modal.querySelector(".modal-search--wrapper");
      setTimeout(() => {
        modalSearchWrapperEl == null ? void 0 : modalSearchWrapperEl.classList.remove("md:translate-y-0");
        modalSearchWrapperEl == null ? void 0 : modalSearchWrapperEl.classList.add("md:translate-y-[-100%]");
      }, 500);
      setTimeout(() => {
        modal.classList.remove("md:translate-y-0");
        modal.classList.add("md:translate-y-[-100%]");
      }, 50);
    }
    this.searchInput.blur();
  }
  async handleSearch(event) {
    var _a, _b, _c;
    const query = ((_c = (_b = (_a = event == null ? void 0 : event.target) == null ? void 0 : _a.value) == null ? void 0 : _b.trim) == null ? void 0 : _c.call(_b)) || "";
    if (query.length < 3) {
      this.searchSuggestion.classList.remove("hidden");
      this.searchAutocomplete.classList.add("hidden");
      this.searchAutocomplete.classList.remove("lg:grid");
      _JK.helpers.addClass(this.noResultsContainer, "hidden");
      return;
    }
    const dataSearchResponse = await this.fetchSearchResults(query, "search");
    const dataSuggestionsResponse = await this.fetchSearchResults(query, "suggestions");
    this.displayPredictiveSearchTerms(dataSuggestionsResponse);
    this.displayResults(dataSearchResponse.results);
  }
  async fetchSearchResults(query = "", type = "suggestions") {
    let endpoint = `${this.config.url.searchEndpoint}&q=${query}&resultsFormat=json&resultsPerPage=5&page=1&redirectResponse=direct`;
    if (type === "suggestions") {
      endpoint = `${this.config.url.suggestionEndPoint}&q=${query}&language=en&suggestionCount=4`;
    }
    try {
      const response = await fetch(endpoint, {
        headers: { "Content-Type": "application/json" }
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching search results:", error);
      return [];
    }
  }
  displayResults(results) {
    const resultContainer = this.searchContainer.querySelector(".autocomplete__products-list");
    _JK.helpers.addClass(this.noResultsContainer, "hidden");
    resultContainer.innerHTML = "";
    if (results.length == 0) {
      _JK.helpers.removeClass(this.noResultsContainer, "hidden");
      this.searchSuggestion.classList.add("hidden");
      this.searchAutocomplete.classList.remove("hidden");
      this.searchAutocomplete.classList.add("lg:grid");
      return;
    }
    const handles = results.slice(0, 5).map((r) => r.handle);
    renderProductCardsFromHandles(handles, resultContainer, {
      view: "get-product-search-card",
      cardClasses: ["basis-[calc(50%-4px)]", "lg:basis-[calc(20%-8px)]"]
    }).then(() => {
      if (this.shadowRoot instanceof ShadowRoot) {
        this.searchAutocomplete.querySelectorAll(".lazyload").forEach((imgLazy) => {
          const src = imgLazy.getAttribute("data-src");
          imgLazy.src = src.replace(/{width}/g, imgLazy.width);
          imgLazy.onload = () => {
            imgLazy.classList.add("lazyloaded");
            imgLazy.classList.remove("lazyload");
          };
        });
      }
      this.noResultsContainer.classList.add("hidden");
      this.searchSuggestion.classList.add("hidden");
      this.searchAutocomplete.classList.remove("hidden");
      this.searchAutocomplete.classList.add("lg:grid");
    });
  }
  displayPredictiveSearchTerms(suggestRes) {
    var _a;
    const autocompleteTerms = this.searchContainer.querySelector(".autocomplete__terms-list");
    if (autocompleteTerms) {
      autocompleteTerms.innerHTML = "";
    }
    let displayCount = 0;
    if (suggestRes.suggested && suggestRes.suggested.text !== null) {
      const $li = this.buildSearchRecommendationLinkItem(suggestRes.suggested.text);
      autocompleteTerms.appendChild($li);
      displayCount = 1;
    }
    if (((_a = suggestRes.alternatives) == null ? void 0 : _a.length) > 0) {
      const { alternatives } = suggestRes;
      alternatives.forEach((alt) => {
        const $li = this.buildSearchRecommendationLinkItem(alt.text);
        autocompleteTerms.appendChild($li);
        displayCount += 1;
      });
    }
    if (displayCount > 0) {
      autocompleteTerms.parentElement.classList.remove("hidden");
    } else {
      autocompleteTerms.parentElement.classList.add("hidden");
    }
    return displayCount;
  }
  buildSearchRecommendationLinkItem(term) {
    const node = document.createElement("li");
    const linkHTML = createLinkFromTemplate("domaine-reg-14-darken", {
      text: term,
      // The visible text of the link
      url: `/search?q=${term.toLowerCase()}`,
      // The link URL, pointing to a search query for the term
      id: `shop-sale-${term.trim().replace(/\s+/g, "-")}`,
      // A unique ID for the link element
      additionalClasses: "lg:py-4 py-6 block"
      // Extra classes if needed (empty for now)
    });
    const temp = document.createElement("div");
    temp.innerHTML = linkHTML;
    const linkNode = temp.firstElementChild;
    node.appendChild(linkNode);
    return node;
  }
  buildRecommendations() {
    const searchTerms = this.SDG.Data.searchRecommendations.split(",");
    const termsList = this.searchContainer.querySelector(".terms__list");
    if (searchTerms && searchTerms.length > 0) {
      searchTerms.forEach((term) => {
        const li = this.buildSearchRecommendationLinkItem(term);
        termsList.appendChild(li);
      });
    }
    let history = localStorage.getItem("search-history");
    if (history) {
      history = JSON.parse(history);
      history.reverse().forEach((term) => {
        const li = this.buildSearchRecommendationLinkItem(term);
        this.searchContainer.querySelector(".history__list").appendChild(li);
        this.searchContainer.querySelector(".history__container").classList.remove("hidden");
      });
    } else {
      this.searchContainer.querySelector(".history__container").classList.add("hidden");
    }
  }
  /**
   * searchIconListener
   *
   * Clones the `.header-utility--search-mobile` element's inner HTML
   * and inserts it into `.js-insert-mobile-search-icon`. Then, sets up
   * a click listener on `.js-insert-mobile-search-icon` to submit the
   * `#navigation-search-form` when clicked.
   */
  searchIconListener() {
    const targetEl = document.querySelector(".js-insert-mobile-search-icon");
    if (targetEl) {
      targetEl.addEventListener("click", () => {
        const searchForm = document.querySelector("#navigation-search-form");
        if (searchForm) searchForm.submit();
      });
    }
  }
  handleSearchResize() {
    const modal = this.searchModal;
    if (!modal) return;
    const wrapper = modal.querySelector(".modal-search--wrapper");
    if (window.innerWidth <= 768) {
      modal.classList.remove("md:translate-y-0", "md:translate-y-[-100%]", "transition-opacity", "translate-x-0");
      wrapper == null ? void 0 : wrapper.classList.remove("md:translate-y-0", "md:translate-y-[-100%]", "translate-x-0");
      modal.classList.add("-translate-x-full", "transition-transform");
      wrapper == null ? void 0 : wrapper.classList.add("-translate-x-full");
    } else {
      modal.classList.remove("translate-x-0", "-translate-x-full");
      wrapper == null ? void 0 : wrapper.classList.remove("translate-x-0", "-translate-x-full");
      modal.classList.remove("md:translate-y-0");
      wrapper == null ? void 0 : wrapper.classList.remove("md:translate-y-0");
      modal.classList.add("md:translate-y-[-100%]", "transition-opacity");
      wrapper == null ? void 0 : wrapper.classList.add("md:translate-y-[-100%]");
    }
  }
  render() {
    var _a, _b;
    this.searchContainer.innerHTML = `
      <div class="search lg:grid-cols-[repeat(24,minmax(0,1fr))] grid-cols-4 grid gap-0">
        <div class="search__wrapper lg:col-span-24 lg:col-start-1 relative col-start-1 col-span-4">
          <form class="navigation-search-form" id="navigation-search-form" action="/search" autocomplete="off">
            <input type="text" name="q" class="redesign-body-3 search-input border-b border-b-solid border-b-[var(--color-charcoal-10)] w-full text-[#49443e] cursor-pointer lg:px-[4.75rem] px-[3rem] py-[0.75rem] focus:outline-0 focus-visible:outline-0 h-[64px]" placeholder="What can we help you find?" aria-label="Search" required>
          </form>
          <button type="button" class="js-insert-mobile-search-icon js-search-button btn-icon btn-search-icon absolute w-16 h-16 -translate-y-2/4 border-[medium] border-none lg:left-[2.5rem] left-20 top-[2rem]" aria-label="Search">
          ${(_b = (_a = window._JK) == null ? void 0 : _a.icons) == null ? void 0 : _b.iconSearch}
          <span class="screenreader sr-only">Submit Search</span>
          </button>
        </div>
        <div class="search__container lg:col-[span_24_/_span_24] lg:col-start-1 lg:pt-28 lg:pb-40 lg:px-40 col-span-4 pt-0 max-h-[100vh] overflow-y-auto">
          <p class="redesign-body-5 text-center hidden js-no-results py-14 lg:py-0 my-16 lg:my-0">No results. Try searching for something else!</p>
          <div class="search-suggestions flex lg:flex-row flex-col items-start justify-center lg:gap-[2.5rem] gap-[1.5rem] p-[1rem] lg:px-[1.5rem] lg:py-0">
            <div class="history__container w-[17rem] p-0">
              <h2 class="redesign-body-6 text-charcoal-100 terms__title lg:mb-16 py-16 lg:p-0">Search History</h2>
              <ul class="history__list flex flex-col gap-0 m-0 lg:p-0 pl-16 pb-20"></ul>
            </div>
            <div class="terms_container w-[17rem] p-0">
              <h2 class="redesign-body-6 text-charcoal-100 terms__title lg:mb-16 py-16 lg:p-0">Popular Search Terms</h2>
              <ul class="terms__list flex flex-col gap-0 lg:m-0 lg:p-0 pl-16 pb-20"></ul>
            </div>
          </div>
          <div class="autocomplete hidden lg:grid-cols-[repeat(24,minmax(0,1fr))] flex-col w-full lg:gap-8 gap-[.75rem] justify-center flex p-[1rem] px-20 lg:p-0" aria-live="polite">
            <div class="autocomplete__terms lg:col-[span_4_/_span_4] lg:col-start-[1] flex flex-col gap-4 lg:gap-16">
              <h2 class="text-charcoal-100 redesign-body-6 px-0 py-15 lg:py-0 autocomplete__terms-title">Top Suggestions</h2>
              <ul class="autocomplete__terms-list flex flex-col gap-0 m-0 pl-16 lg:p-0"></ul>
            </div>
            <div class="autocomplete__item lg:col-[span_20_/_span_20] lg:col-start-[5]">
              <div class="autocomplete__products-list w-full max-w-screen flex flex-row lg:gap-x-8 gap-x-8 gap-y-32 flex-wrap justify-start lg:justify-end h-full lg:mt-0 mt-20 m-0 px-0 pt-0 pb-[5rem] lg:pb-0"></div>
            </div>
          </div>
        </div>
      </div>
    `;
  }
}
class CountrySelectorDrawer {
  constructor(root = document) {
    var _a;
    this.rootInstance = root;
    this.boundOpenDrawer = this.openDrawer.bind(this);
    this.boundCloseDrawer = this.closeDrawer.bind(this);
    this.boundHandleCountryChange = this.handleCountryChange.bind(this);
    this.boundHandleSubmit = this.handleSubmit.bind(this);
    this.boundHandleOutsideClick = this.handleOutsideClick.bind(this);
    this.hasAttachedListeners = false;
    this.container = this.rootInstance.querySelector(
      ".country-selector-drawer"
    );
    if (!this.container) {
      console.warn(
        "CountrySelectorDrawer: Drawer container not found (.country-selector-drawer). Exiting."
      );
      return;
    }
    this.drawerTriggers = this.rootInstance.querySelectorAll(
      ".js-open-country-selector"
    );
    if (!((_a = this.drawerTriggers) == null ? void 0 : _a.length)) {
      console.warn(
        "CountrySelectorDrawer: No trigger element found (.js-open-country-selector). Exiting."
      );
      return;
    }
  }
  init() {
    var _a, _b, _c, _d, _e, _f, _g;
    if (!((_a = this.drawerTriggers) == null ? void 0 : _a.length)) return;
    this.backdrop = this.rootInstance.querySelector("#country-drawer-backdrop");
    this.closeBtn = this.container.querySelector(".close-btn");
    this.submitBtn = this.container.querySelector(".js-submit-country-selector");
    this.hiddenInput = this.container.querySelector(".js-country-code-input");
    this.countrySelectorDrawerAction = this.container.querySelector(".countrySelector__drawer-actions");
    this.currentCountryCode = ((_c = (_b = this.hiddenInput) == null ? void 0 : _b.defaultValue) == null ? void 0 : _c.trim()) || ((_e = (_d = this.hiddenInput) == null ? void 0 : _d.value) == null ? void 0 : _e.trim()) || "";
    this.defaultSubmitLabel = ((_g = (_f = this.submitBtn) == null ? void 0 : _f.textContent) == null ? void 0 : _g.trim()) || "";
    this.setCtaDisabled(true);
    this.attachListeners();
    this.CountrySelectorAccordion();
  }
  getDrawerTriggers() {
    return this.rootInstance.querySelectorAll(".js-open-country-selector");
  }
  // Enable/disable CTA button
  setCtaDisabled(isDisabled) {
    if (!this.submitBtn) return;
    this.countrySelectorDrawerAction.classList.toggle("cursor-not-allowed", isDisabled);
    this.submitBtn.classList.toggle("pointer-events-none", isDisabled);
    this.submitBtn.classList.toggle("cursor-not-allowed", isDisabled);
    this.submitBtn.classList.toggle("pointer-events-auto", !isDisabled);
    this.submitBtn.classList.toggle("cursor-pointer", !isDisabled);
    this.submitBtn.setAttribute("aria-disabled", isDisabled ? "true" : "false");
    if (isDisabled) this.submitBtn.setAttribute("tabindex", "-1");
    else this.submitBtn.removeAttribute("tabindex");
  }
  CountrySelectorAccordion() {
    const accordionEl = this.rootInstance.querySelector("#country-selector-accordion");
    if (accordionEl) {
      const accordion = SDG.accordion({
        dom: {
          btn: "js-acc-btn",
          id: "country-selector-accordion",
          menu: "js-acc-menu"
        }
      }, this.rootInstance);
      accordion.init(this.rootInstance);
    }
  }
  attachListeners() {
    var _a, _b, _c, _d, _e;
    if (this.hasAttachedListeners) return;
    (_a = this.drawerTriggers) == null ? void 0 : _a.forEach((trigger) => {
      trigger.addEventListener("click", this.boundOpenDrawer);
    });
    (_b = this.closeBtn) == null ? void 0 : _b.addEventListener("click", this.boundCloseDrawer);
    (_c = this.container) == null ? void 0 : _c.addEventListener("click", (e) => {
      if (!e.target.closest(".main-dialog")) {
        this.closeDrawer();
      }
    });
    (_d = this.container) == null ? void 0 : _d.addEventListener("change", this.boundHandleCountryChange);
    (_e = this.submitBtn) == null ? void 0 : _e.addEventListener("click", this.boundHandleSubmit);
    this.rootInstance.addEventListener("click", this.boundHandleOutsideClick);
    document.addEventListener("jk:open-country-selector", this.boundOpenDrawer);
    this.hasAttachedListeners = true;
  }
  handleCountryChange(event) {
    var _a, _b, _c;
    const radio = event.target.closest(".js-country-radio");
    if (!radio) return;
    const nameEl = (_a = radio.closest("label")) == null ? void 0 : _a.querySelector(".js-country-name");
    const countryTitle = ((_b = nameEl == null ? void 0 : nameEl.dataset) == null ? void 0 : _b.countryTitle) || ((_c = nameEl == null ? void 0 : nameEl.textContent) == null ? void 0 : _c.trim());
    if (!countryTitle) return;
    this.submitBtn.textContent = `Shop In ${countryTitle}`;
    const newCode = radio.value;
    const hasChanged = this.currentCountryCode ? newCode !== this.currentCountryCode : Boolean(newCode);
    this.setCtaDisabled(!hasChanged);
    if (this.hiddenInput) this.hiddenInput.value = newCode;
  }
  getCountryTitleByCode(countryCode) {
    var _a, _b, _c, _d;
    if (!countryCode) return "";
    const radio = (_a = this.container) == null ? void 0 : _a.querySelector(`.js-country-radio[value="${countryCode}"]`);
    if (!radio) return "";
    const nameEl = (_b = radio.closest("label")) == null ? void 0 : _b.querySelector(".js-country-name");
    return (((_c = nameEl == null ? void 0 : nameEl.dataset) == null ? void 0 : _c.countryTitle) || ((_d = nameEl == null ? void 0 : nameEl.textContent) == null ? void 0 : _d.trim()) || "").trim();
  }
  resetSelectionToCurrentCountry() {
    var _a, _b, _c, _d, _e;
    const currentCode = this.currentCountryCode || ((_b = (_a = this.hiddenInput) == null ? void 0 : _a.defaultValue) == null ? void 0 : _b.trim()) || ((_d = (_c = this.hiddenInput) == null ? void 0 : _c.value) == null ? void 0 : _d.trim()) || "";
    if (!currentCode) return;
    const allRadios = ((_e = this.container) == null ? void 0 : _e.querySelectorAll(".js-country-radio")) || [];
    allRadios.forEach((radioEl) => {
      const shouldBeChecked = radioEl.value === currentCode;
      radioEl.checked = shouldBeChecked;
      if (shouldBeChecked) {
        radioEl.setAttribute("checked", "checked");
      } else {
        radioEl.removeAttribute("checked");
      }
    });
    if (this.hiddenInput) this.hiddenInput.value = currentCode;
    const countryTitle = this.getCountryTitleByCode(currentCode);
    if (this.submitBtn) {
      this.submitBtn.textContent = countryTitle ? `Shop In ${countryTitle}` : this.defaultSubmitLabel;
    }
    this.setCtaDisabled(true);
  }
  handleSubmit(event) {
    event.preventDefault();
    const form = this.container.querySelector(".js-localization-form");
    form == null ? void 0 : form.submit();
  }
  handleOutsideClick(event) {
    if (!this.container.classList.contains("open")) return;
    const clickedTrigger = [...this.getDrawerTriggers()].some((trigger) => trigger.contains(event.target));
    if (!this.container.contains(event.target) && !clickedTrigger) {
      this.closeDrawer();
    }
  }
  openDrawer(e) {
    var _a, _b;
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    (_a = this.backdrop) == null ? void 0 : _a.classList.add("opacity-100");
    (_b = this.backdrop) == null ? void 0 : _b.classList.remove("opacity-0", "pointer-events-none");
    this.container.classList.remove("translate-x-full");
    this.container.classList.add("open");
    _JK.helpers.addClass(document.body, "overflow-hidden");
    this.resetSelectionToCurrentCountry();
    this.getDrawerTriggers().forEach((trigger) => {
      trigger.setAttribute("aria-expanded", "true");
    });
  }
  closeDrawer() {
    var _a, _b;
    this.resetSelectionToCurrentCountry();
    this.container.classList.add("translate-x-full");
    this.container.classList.remove("open");
    (_a = this.backdrop) == null ? void 0 : _a.classList.remove("opacity-100");
    (_b = this.backdrop) == null ? void 0 : _b.classList.add("opacity-0", "pointer-events-none");
    _JK.helpers.removeClass(document.body, "overflow-hidden");
    this.getDrawerTriggers().forEach((trigger) => {
      trigger.setAttribute("aria-expanded", "false");
    });
  }
}
class CustomFooter {
  constructor(root = document) {
    this.root = root;
    this.form = this.root.getElementById("custom-footer-form");
    this.emailInput = this.root.getElementById("email");
    this.klaviyoSource = this.root.getElementById("klaviyo_source");
    this.klaviyoListId = this.root.getElementById("klaviyo_list_id");
    this.footerConfirmation = this.root.getElementById("js-footer-confirmation");
    this.boundHandleOsanoLinkClick = this.handleOsanoLinkClick.bind(this);
    if (this.form && this.emailInput) {
      this.init();
    }
    this.root.addEventListener("click", this.boundHandleOsanoLinkClick);
    const accordion = SDG.accordion({
      dom: {
        btn: "js-acc-btn",
        id: "footerAccordion",
        menu: "js-acc-menu"
      }
    }, this.root);
    accordion.init(this.root);
    this.root.addEventListener("click", this.handleCountrySelectorTrigger.bind(this));
  }
  init() {
    this.form.addEventListener("submit", this.handleSubmit.bind(this));
  }
  handleOsanoLinkClick(event) {
    var _a, _b, _c;
    const target = event.target instanceof Element ? event.target : null;
    const trigger = target == null ? void 0 : target.closest("[data-osano-action]");
    if (!trigger) return;
    event.preventDefault();
    const action = trigger.dataset.osanoAction;
    const osanoCm = (_a = window.Osano) == null ? void 0 : _a.cm;
    if (!osanoCm) {
      console.warn("[CustomFooter] Osano consent manager is unavailable.");
      return;
    }
    if (action === "show-do-not-sell") {
      (_b = osanoCm.showDoNotSell) == null ? void 0 : _b.call(osanoCm);
      return;
    }
    if (action === "show-drawer") {
      const drawerId = trigger.dataset.osanoDrawerId;
      if (!drawerId) return;
      (_c = osanoCm.showDrawer) == null ? void 0 : _c.call(osanoCm, drawerId);
    }
  }
  handleCountrySelectorTrigger(event) {
    const trigger = event.target.closest(".js-open-country-selector");
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    document.dispatchEvent(new CustomEvent("jk:open-country-selector"));
  }
  async handleSubmit(e) {
    e.preventDefault();
    e.stopPropagation();
    const email = this.emailInput.value;
    const listId = this.klaviyoListId ? this.klaviyoListId.value : "K7TCDD";
    const source = this.klaviyoSource ? this.klaviyoSource.value : "Footer Form";
    const options = {
      method: "POST",
      headers: {
        accept: "application/vnd.api+json",
        revision: "2025-01-15",
        "content-type": "application/vnd.api+json"
      },
      body: JSON.stringify({
        data: {
          type: "subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email
                }
              }
            },
            custom_source: source
          },
          relationships: {
            list: {
              data: {
                type: "list",
                id: listId
              }
            }
          }
        }
      })
    };
    try {
      const response = await fetch("https://a.klaviyo.com/client/subscriptions?company_id=Ppytcf", options);
      if (response.ok) {
        this.form.classList.add("hidden");
        this.footerConfirmation.classList.remove("hidden");
      } else {
        const errorText = await response.text();
        console.error("[CustomFooter] Error response:", errorText);
        alert("Error subscribing. Please try again.");
      }
    } catch (error) {
      console.error("[CustomFooter] Network or fetch failure:", error);
      alert("Error subscribing. Please try again later.");
    }
  }
}
function initOsanoDialogGuards() {
  var _a;
  if ((_a = window._JK) == null ? void 0 : _a.osanoDialogGuardsInitialized) {
    return;
  }
  window._JK = window._JK || {};
  window._JK.osanoDialogGuardsInitialized = true;
  const OPEN_CLASS = "osano-dialog-open";
  const DIALOG_SELECTOR = ".osano-cm-dialog";
  const WINDOW_SELECTOR = ".osano-cm-window";
  let rafId = null;
  let lastOpenState = null;
  let observedTarget = null;
  const getDialog = () => {
    const dialogs = Array.from(document.querySelectorAll(DIALOG_SELECTOR));
    return dialogs.find((dialog) => {
      if (!dialog) return false;
      if (dialog.classList.contains("osano-cm-dialog--hidden")) return false;
      if (dialog.getAttribute("aria-hidden") === "true") return false;
      if (dialog.hasAttribute("hidden")) return false;
      return dialog.offsetParent !== null;
    }) || null;
  };
  const isDialogOpen = () => !!getDialog();
  const syncState = () => {
    const open = isDialogOpen();
    if (open === lastOpenState) return;
    lastOpenState = open;
    document.documentElement.classList.toggle(OPEN_CLASS, open);
    document.body.classList.toggle(OPEN_CLASS, open);
  };
  const scheduleSyncState = () => {
    if (rafId !== null) return;
    rafId = window.requestAnimationFrame(() => {
      rafId = null;
      syncState();
      ensureObservedTarget();
    });
  };
  const mutationObserver = new MutationObserver(() => {
    scheduleSyncState();
  });
  const observeTarget = (target) => {
    if (!target || target === observedTarget) return;
    mutationObserver.disconnect();
    observedTarget = target;
    mutationObserver.observe(target, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "style", "hidden", "aria-hidden"]
    });
  };
  const ensureObservedTarget = () => {
    const osanoWindow = document.querySelector(WINDOW_SELECTOR);
    observeTarget(osanoWindow || document.body);
  };
  const blockOutsidePointer = (event) => {
    if (!isDialogOpen()) return;
    const dialog = getDialog();
    if (!dialog || dialog.contains(event.target)) return;
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === "function") {
      event.stopImmediatePropagation();
    }
  };
  const blockBackgroundScroll = (event) => {
    if (!isDialogOpen()) return;
    const dialog = getDialog();
    if (!dialog || dialog.contains(event.target)) return;
    event.preventDefault();
  };
  document.addEventListener("pointerdown", blockOutsidePointer, true);
  document.addEventListener("touchstart", blockOutsidePointer, { passive: false, capture: true });
  document.addEventListener("click", blockOutsidePointer, true);
  document.addEventListener("wheel", blockBackgroundScroll, { passive: false, capture: true });
  document.addEventListener("touchmove", blockBackgroundScroll, { passive: false, capture: true });
  ensureObservedTarget();
  scheduleSyncState();
}
class StickyHeader extends HTMLElement {
  constructor() {
    var _a, _b, _c, _d, _e, _f;
    super();
    this.sticky = false;
    const root = this.getRootNode();
    this.headerHeight = (_a = root == null ? void 0 : root.querySelector(".header-nav--wrapper")) == null ? void 0 : _a.getBoundingClientRect();
    this.pencilBanner = (_b = root == null ? void 0 : root.querySelector(".redesign-pencil-banner")) == null ? void 0 : _b.getBoundingClientRect();
    this.scrollThreshold = (_c = this.headerHeight) == null ? void 0 : _c.height;
    if ((_d = this.pencilBanner) == null ? void 0 : _d.height) {
      this.scrollThreshold = ((_e = this.headerHeight) == null ? void 0 : _e.height) + ((_f = this.pencilBanner) == null ? void 0 : _f.height);
    }
    this.handleScroll();
  }
  connectedCallback() {
    window.addEventListener("scroll", this.handleScroll.bind(this));
  }
  handleScroll() {
    const scrollTop = window.scrollY;
    const root = this.getRootNode();
    const modalSearch = root.querySelector(".modal-search");
    const header = this.querySelector("header");
    if (scrollTop > this.scrollThreshold && !this.sticky) {
      this.sticky = true;
      header.classList.add("sticky");
      header.style.top = "0";
      header.style.position = "fixed";
      if (modalSearch) {
        modalSearch.style.position = "fixed";
        modalSearch.style.top = 0;
      }
    } else if (scrollTop <= this.scrollThreshold && this.sticky) {
      this.sticky = false;
      document.querySelector("main").removeAttribute("style");
      header.classList.remove("sticky");
      header.style.position = header.classList.contains("is--homepage") ? "absolute" : "relative";
      if (modalSearch) modalSearch.removeAttribute("style");
    }
  }
  disconnectedCallback() {
    window.removeEventListener("scroll", this.handleScroll);
  }
}
customElements.define("sticky-header", StickyHeader);
function processGWP(root = document) {
  if (!window._JK) window._JK = {};
  if (!_JK.GWP || !_JK.GWP.active) return;
  if (!window._JK.Cart) window._JK.Cart = new JKCart();
  const cart2 = _JK.Cart;
  const COOKIE_NAME = _JK.GWP.cookieName || "freeGiftDismissed";
  const cartComponentObject = getCartInstance(root);
  let opPromise = null;
  let evalTimer = null;
  const withGate = (fn) => {
    if (opPromise) return opPromise;
    opPromise = (async () => {
      try {
        return await fn();
      } finally {
        opPromise = null;
      }
    })();
    return opPromise;
  };
  const scheduleEvaluate = () => {
    if (evalTimer) clearTimeout(evalTimer);
    evalTimer = setTimeout(() => {
      evaluate();
    }, 120);
  };
  const parseProductIdArray = (value) => {
    if (!value) return [];
    if (Array.isArray(value)) {
      return value.map((v) => Number(String(v).trim().replace(/^['"]|['"]$/g, ""))).filter((n) => Number.isFinite(n) && n > 0);
    }
    const str = String(value).trim();
    if (!str) return [];
    const looksLikeArray = str.startsWith("[") && str.endsWith("]");
    if (looksLikeArray) {
      try {
        const normalized = str.replace(/'/g, '"');
        const parsed = JSON.parse(normalized);
        if (Array.isArray(parsed)) {
          return parsed.map((v) => Number(String(v).trim().replace(/^['"]|['"]$/g, ""))).filter((n) => Number.isFinite(n) && n > 0);
        }
      } catch (e) {
        console.warn("[GWP] Failed to parse product_type_products as JSON, falling back to best-effort parsing", e);
      }
    }
    return str.replace(/^\[|\]$/g, "").split(",").map((s) => Number(s.trim().replace(/^['"]|['"]$/g, ""))).filter((n) => Number.isFinite(n) && n > 0);
  };
  const gwp_cfg = {
    cartDrawer: root.querySelector("#drawerPanel") || root.querySelector("#cartPage"),
    type: (_JK.GWP.type || "").toString().trim(),
    autoOrManual: (_JK.GWP.autoOrManual || "").toString().trim(),
    minPrice: Number(_JK.GWP.minPrice || 0),
    firstVariantId: Number(_JK.GWP.firstVariantId || 0),
    autoAddVariantId: Number(_JK.GWP.autoAddVariantId || 0),
    // Gift product id(s) used to identify gift line items (plus _freeGift prop & $0 fallback)
    productIds: _JK.GWP.productIds || [],
    productHandle: (_JK.GWP.productHandle || "").toString().trim(),
    isMultiVariant: _JK.GWP.isMultiVariant,
    // NEW: trigger products (ANY one present in cart => eligible when type === 'product')
    productTypeProducts: parseProductIdArray(_JK.GWP.product_type_products)
  };
  const isAuto = () => !gwp_cfg.isMultiVariant && gwp_cfg.autoOrManual === "auto";
  const getCustomerEligible = () => {
    const gwp_banner = gwp_cfg.cartDrawer.querySelector('[data-gwp="banner"]');
    if (!gwp_banner) return false;
    return gwp_banner.getAttribute("data-gwp-customer-eligible") === "true";
  };
  const getProductEligible = (cartJson) => {
    const triggers = gwp_cfg.productTypeProducts;
    if (!triggers.length) return false;
    if (!cartJson || !Array.isArray(cartJson.items)) return false;
    return cartJson.items.some((item) => triggers.includes(Number(item == null ? void 0 : item.product_id)));
  };
  const resolveEligible = (cartJson) => {
    if (gwp_cfg.type === "customer") return getCustomerEligible();
    if (gwp_cfg.type === "product") return getProductEligible(cartJson);
    return true;
  };
  const findGiftLine = (cartJson) => {
    var _a;
    if (!cartJson || !Array.isArray(cartJson.items)) return null;
    for (const item of cartJson.items) {
      const isGiftProp = ["1", 1, true, "true"].includes((_a = item == null ? void 0 : item.properties) == null ? void 0 : _a._freeGift);
      const isGiftProduct = gwp_cfg.productIds.includes(Number(item.product_id));
      const isZero = Number(item.final_line_price) === 0;
      if (isGiftProp || isGiftProduct && isZero) return item;
    }
    return null;
  };
  const findBadGiftLine = (cartJson) => {
    if (!cartJson || !Array.isArray(cartJson.items)) return null;
    const giftItems = cartJson.items.filter(
      (item) => {
        var _a;
        return ["1", 1, true, "true"].includes((_a = item == null ? void 0 : item.properties) == null ? void 0 : _a._freeGift);
      }
    );
    if (giftItems.length <= 1) return null;
    for (const item of giftItems) {
      const isZero = Number(item.final_line_price) === 0;
      if (!isZero) return item;
    }
    return null;
  };
  const thresholdMet = (cartJson, giftLine) => {
    const subtotal = Number((cartJson == null ? void 0 : cartJson.items_subtotal_price) || 0);
    const giftPrice = Number((giftLine == null ? void 0 : giftLine.final_line_price) || 0);
    return subtotal - giftPrice >= gwp_cfg.minPrice;
  };
  const addGift = async (isauto = false) => {
    const variantId = gwp_cfg.autoAddVariantId;
    if (!variantId) return;
    if (isauto && SDG.getCookie(COOKIE_NAME)) return;
    return withGate(async () => {
      var _a;
      try {
        await cart2.addItem(variantId, 1, { _freeGift: 1 });
        await ((_a = cartComponentObject.renderCart) == null ? void 0 : _a.call(cartComponentObject));
        SDG.deleteCookie(COOKIE_NAME);
      } catch (e) {
        console.warn("[GWP] add failed", e);
      } finally {
        CleanUpAnyDuplicates();
      }
    });
  };
  const removeGift = async (giftLine) => {
    if (!giftLine || !giftLine.key) return;
    return withGate(async () => {
      var _a;
      try {
        await cart2.updateItem(giftLine.key, 0);
        await ((_a = cartComponentObject.renderCart) == null ? void 0 : _a.call(cartComponentObject));
      } catch (e) {
        console.warn("[GWP] remove failed", e);
      }
    });
  };
  const evaluate = async () => {
    try {
      if (opPromise) {
        await opPromise;
      }
      const cartJson = await cart2.fetchCart();
      const giftLine = findGiftLine(cartJson);
      const overThreshold = thresholdMet(cartJson, giftLine);
      const eligible = resolveEligible(cartJson);
      if (isAuto() && overThreshold && eligible && !giftLine) {
        await addGift(true);
        return;
      }
      if ((!overThreshold || !eligible) && giftLine) {
        await removeGift(giftLine);
        return;
      }
    } catch (e) {
      console.warn("[GWP] evaluate error", e);
    }
  };
  const onBannerClick = async (e) => {
    const cta = e.target.closest("#gwp_cta");
    if (!cta) return;
    e.preventDefault();
    e.stopPropagation();
    if (opPromise) {
      return;
    }
    const variantId = Number(cta.getAttribute("data-variant-id") || 0);
    try {
      const cartJson = await cart2.fetchCart();
      const giftLine = findGiftLine(cartJson);
      const overThreshold = thresholdMet(cartJson, giftLine);
      const eligible = resolveEligible(cartJson);
      if (!overThreshold || !eligible) return;
      if (variantId) await addGift(false);
    } catch (err) {
      console.warn("[GWP] CTA error", err);
    }
  };
  const bindGWPEvents = () => {
    const ctaButton = gwp_cfg.cartDrawer.querySelector("#gwp_cta");
    if (ctaButton && ctaButton.classList.contains("auto-add")) {
      ctaButton.addEventListener("click", onBannerClick);
    }
  };
  const CleanUpAnyDuplicates = async (snapshot) => {
    try {
      let cartJson = snapshot;
      if (!(cartJson == null ? void 0 : cartJson.items)) {
        cartJson = await cart2.fetchCart();
      }
      const badGiftLine = findBadGiftLine(cartJson);
      if (!(badGiftLine == null ? void 0 : badGiftLine.key)) return;
      await withGate(async () => {
        var _a;
        await cart2.updateItem(badGiftLine.key, 0);
        await ((_a = cartComponentObject.renderCart) == null ? void 0 : _a.call(cartComponentObject));
      });
    } catch (e) {
      console.warn("[GWP] CleanUpAnyDuplicates error", e);
    }
  };
  const ready = async () => {
    var _a;
    const bagEmpty = !((_a = _JK == null ? void 0 : _JK.Bag) == null ? void 0 : _a.items) || _JK.Bag.items.length === 0;
    if (bagEmpty) {
      try {
        await cart2.fetchCart();
      } catch (e) {
        console.warn("[GWP] initial fetchCart failed", e);
      }
    }
    bindGWPEvents();
    scheduleEvaluate();
    await CleanUpAnyDuplicates(_JK.Bag);
    window.addEventListener("jkCart:bindEvents", scheduleEvaluate, { passive: true });
    window.addEventListener("jkCart:bindEvents", bindGWPEvents, { passive: true });
  };
  if (document.readyState === "complete" || document.readyState === "interactive") {
    ready();
  } else {
    document.addEventListener("DOMContentLoaded", ready, { once: true });
  }
}
export {
  AccountDrawer as A,
  CountrySelectorDrawer as C,
  RedesignMegaMenu as R,
  SearchSpringElement as S,
  CustomFooter as a,
  initOsanoDialogGuards as i,
  processGWP as p
};
